/*
 * 商品信息
 */
/*eslint-disable*/

import store from '../index'
import {findByShopIdForShop,getIndexTypeAll,getIndexOneType} from '../../api/goods'
// 显示所有商品-傳SHOPID即查詢店鋪商品
export function findByShopIdForShopList({ commit }, data) {
    return new Promise((resolve, reject) => {
        findByShopIdForShop( data ).then( (res) => {
            resolve(res);
            commit('setGoodsList', res.data);
        }).catch(error => {
            reject(error)
        })
    })
}
// 获取全部分類
export function getIndexTypeAllList({ commit }) {
    return new Promise((resolve, reject) => {
        getIndexTypeAll().then( (res) => {
            resolve(res);
            commit('setIndexTypeAllList', res.data);
        }).catch(error => {
            reject(error)
        })
    })
}
// 获取一级分類
export function getIndexTypeOneList({ commit }) {
    return new Promise((resolve, reject) => {
        getIndexOneType().then( (res) => {
            resolve(res);
            commit('setIndexTypeOneList', res.data);
        }).catch(error => {
            reject(error)
        })
    })
}
